<h1 mat-dialog-title i18n>
	Accepted Legals <small class="align-top">- {{dialogData.user.email}}</small>

	<button
		mat-flat-button
		type="button"
		color="primary"
		class="float-right user-term-accept"
		(click)="acceptTerm()"
		title="Accept term on behalf of user."
		i18n-title
		style="margin-top: -5px;"
	>Accept Term</button>
</h1>

<form [formGroup]="formInputs">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<div class="col-12" *ngIf="acceptedTerms.length === 0 && loaded">
				<p i18n>No legal acceptances has been recorded against this user account.</p>
			</div>
			<div class="col-12 mb-3" [ngClass]="{'hide-element': acceptedTerms.length === 0 || !loaded}">
				<div class="table-responsive">
					<table mat-table matSort [dataSource]="acceptedTermsPaginated" class="w-100" multiTemplateDataRows aria-label="List of user accepted legal documents">
						<ng-container matColumnDef="displayName">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<button i18n-title title="View selected version" type="button" class="button-link" (click)="viewTerm(row, formInputs.controls[row.termsId + 'Version'].value?.version)">
									{{ row.displayName }}
								</button>
							</td>
						</ng-container>

						<ng-container matColumnDef="version">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Accepted versions</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<mat-select auto class="text-right" formControlName="{{row.termsId}}Version" style="width: auto;">
									<mat-option *ngFor="let version of object.values(row.versions).reverse()" [value]="version">
										{{version.displayVersion}}
									</mat-option>
								</mat-select>
							</td>
						</ng-container>

						<ng-container matColumnDef="acceptedBy">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Accepted by<mat-icon
								matTooltip="Client ID used to accept the legals."
								i18n-matTooltip
								class="ml-2 paragraph-icon"
							>info</mat-icon></th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<button title="Copy client ID to clipboard" [appCopyToClipboard]="formInputs.controls[row.termsId + 'Version'].value?.clientId" [appCopyToClipboardIcon]="true" i18n-title type="button" class="button-link">
									{{formInputs.controls[row.termsId + 'Version'].value?.clientId}}
								</button>
							</td>
						</ng-container>

						<ng-container matColumnDef="acceptedOn">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Accepted on</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								{{ formInputs.controls[row.termsId + 'Version'].value?.ts | localizedDate }}
							</td>
						</ng-container>

						<ng-container matColumnDef="action" [stickyEnd]="true">
							<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
							<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
								<button
									mat-icon-button
									[matMenuTriggerFor]="actionMenu"
									#menuTrigger="matMenuTrigger"
									aria-label="Action menu button"
									title="Available actions"
									i18n-title
									(menuClosed)="openedMenu = null"
									(menuOpened)="openedMenu = i"
									type="button"
									class="user-terms-actions"
								>
									<mat-icon>more_vert</mat-icon>
								</button>

								<mat-menu #actionMenu="matMenu">
									<button
										mat-menu-item
										i18n
										title="View selected version"
										i18n-title
										(click)="viewTerm(row, formInputs.controls[row.termsId + 'Version'].value?.version)"
									>View selected version</button>
									<button
										mat-menu-item
										i18n
										title="Revoke latest acceptance"
										i18n-title
										(click)="confirmRevokeTermAcceptance(row.termsId)"
										class="user-terms-actions__revoke"
									>Revoke latest acceptance</button>
								</mat-menu>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
						<tr
							mat-row
							*matRowDef="let row; columns: tableColumns; let i = dataIndex;"
							[ngClass]="{'menuOpen': openedMenu === i}"
							id="{{row.termsId}}"
						></tr>
					</table>
				</div>
				<mat-paginator
					*ngIf="acceptedTerms && acceptedTerms?.length > 5"
					[length]="acceptedTerms?.length"
					[pageSize]="pageSize"
					[pageIndex]="pageIndex"
					[pageSizeOptions]="[10, 25, 50]"
					(page)="paginateResults($event)"
				></mat-paginator>
			</div>
		</div>
	</div>
</form>

<div mat-dialog-actions class="row px-1 mb-0 justify-content-center">
	<div class="col-6 text-center">
		<button
			class="w-100"
			type="button"
			mat-dialog-close
			mat-flat-button
			i18n
		>Close</button>
	</div>
</div>
